import template   from './user-card.html'

let component = {
  restrict: 'E',
  bindings: {
    card: '<',
    onRemoveCard: '&'
  },
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/components/user-card/user-card.component.js